import React from 'react';

const DropDownIcon = ({ color }) => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M5.00586 6.66296C4.31919 6.66296 3.94278 7.44212 4.35486 7.99129C4.97986 8.82462 8.72978 13.8246 9.35486 14.6579C9.68819 15.1021 10.3496 15.1021 10.6829 14.6579L15.6829 7.99129C16.0949 7.44212 15.6926 6.66296 15.0059 6.66296H5.00586Z'
        fill={color}
      />
    </svg>
  );
};
export default DropDownIcon;
